import { connect } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import type {
  OnVisiblePayload,
  ThumbnailsDispatchProps,
  ThumbnailsStateProps,
} from 'src/components/molecules/Thumbnails/Thumbnails';
import { Thumbnails } from 'src/components/molecules/Thumbnails/Thumbnails';
import type {
  NextOrPreviousPayload,
  SetCurrentImagePayload,
} from 'src/components/organisms/ProductImagesCarousel/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductMedia } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productImagesCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';

const mapStateToProps = (state: ReduxApplicationState): ThumbnailsStateProps => {
  return {
    media: selectProductMedia(state),
    currentImage: state.productImagesCarousel.currentImage,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ThumbnailsDispatchProps => {
  return {
    onVisible: ({ totalImages }: OnVisiblePayload) => {
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event',
          event_category: 'Image carousel',
          event_action: 'Impression',
          event_label: String(totalImages),
        }),
      );
    },
    onNextImage: (payload: NextOrPreviousPayload) => {
      dispatch(actions.nextImage(payload));
    },
    onPrevImage: (payload: NextOrPreviousPayload) => {
      dispatch(actions.prevImage(payload));
    },
    setCurrentImage: (payload: SetCurrentImagePayload) =>
      dispatch(actions.setCurrentImage(payload)),
  };
};

export const ThumbnailsContainer = connect(mapStateToProps, mapDispatchToProps)(Thumbnails);
